// Constants
import { Endpoints } from "~constants/endpoints"

// Utils
import { Api } from "~utils/api"
import { urlQueryBuilder } from "~utils/utils"

// Shapes
import { MessageShape, PostMessageShape } from "~shapes/message"
import { TableOptionsShape } from "~shapes/api-table"

const MessageService = {
  getMessages: async (options?: TableOptionsShape) => {
    let messagesUrl = `${Endpoints.MESSAGES.URL}?projection=includeCompany&sort=communicationLevelPinned,desc&sort=createdAt,desc`
    if (options) {
      const query = urlQueryBuilder(options)
      messagesUrl = `${messagesUrl}&${query}`
    }
    try {
      const response = await Api.get(messagesUrl)
      return response.data
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getMessage: async (id: string) => {
    const messageUrl = `${Endpoints.MESSAGES.URL}/${id}?projection=includeCompany`
    const response = await Api.get(messageUrl)
    return response.data
  },
  postMessage: async (message: PostMessageShape) => {
    const response = await Api.post(Endpoints.MESSAGES.URL, message)
    return response.data
  },
  patchMessage: async (message: Partial<MessageShape>) => {
    const { id, ...rest } = message
    const messageUrl = `${Endpoints.MESSAGES.URL}/${id}`
    try {
      const response = await Api.patch(messageUrl, rest)
      return response.data
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getMessagesByCompany: async (id: string, options?: TableOptionsShape) => {
    let companyMessagesUrl = Endpoints.COMPANY_MESSAGES.URL.replace(":id", id)
    if (options) {
      const query = urlQueryBuilder(options)
      companyMessagesUrl = `${companyMessagesUrl}&${query}`
    }
    try {
      const response = await Api.get(companyMessagesUrl)
      return response.data
    } catch (error) {
      return Promise.reject(error)
    }
  },
}

export default MessageService
